import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import wishlistServices from './wish_list_services';

export const UserWishListCreation = createAsyncThunk(
  'user_wish_list/create_wish_list',
  async (payload, thunkAPI) => {
    try {
      let response = await wishlistServices.wishlistCreation(payload);

      return response;
    } catch (error) {
       toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserMajorWishListCreation = createAsyncThunk(
  'user_wish_list/create_major_wish_list',
  async (payload, thunkAPI) => {
    try {
      let response = await wishlistServices.wishlistCreation(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserGetWishList = createAsyncThunk(
  'user_wish_list/get_wish_list',
  async (_, thunkAPI) => {
    try {
      let response = await wishlistServices.getWishList();

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserGetSingleWishList = createAsyncThunk(
  'user_wish_list/get_single_wish_list',
  async (payload, thunkAPI) => {
    try {
      let response = await wishlistServices.getSingleWishList(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserClearWishList = createAsyncThunk(
  'user_wish_list/clear_wish_list',
  async (payload, thunkAPI) => {
    try {
      let response = await wishlistServices.clearWishList(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const UserRemoveWishList = createAsyncThunk(
  'user_wish_list/remove_wish_list',
  async (payload, thunkAPI) => {
    try {
      let response = await wishlistServices.removeWishList(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
